import { SvgName } from '@/svg'

export type ContactProps = {
  title: string
  href: string
  startIcon?: SvgName
}

export const contacts: ContactProps[] = [
  {
    title: '83 99322-6001',
    href: 'https://wa.me/5583993226001',
    startIcon: 'phone'
  },
  {
    title: 'atendimento@zeniteconstrucoes.com.br',
    href: 'mailto:atendimento@zeniteconstrucoes.com.br',
    startIcon: 'mail'
  }
]
